import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getWeavingReport, getNext, handleSearch } from "./thunk";

const initialState = {
  weavings: [],
  count: null,
  next: null,
  previous: null,
  loadingNext: false,
  loadingWeaving: false,
};

export const weavingReportSlice = createSlice({
  name: "weavingReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNext.pending, (state) => {
      state.loadingNext = true;
    });
    builder.addCase(getNext.fulfilled, (state, action) => {
      state.loadingNext = false;
      state.next = action.payload.next;
      state.weavings = [...state.weavings, ...action.payload.results];
    });
    builder.addCase(getNext.rejected, (state) => {
      state.loadingNext = false;
    });
    builder.addMatcher(isAnyOf(getWeavingReport.pending, handleSearch.pending), (state) => {
      state.loadingWeaving = true;
    });
    builder.addMatcher(isAnyOf(getWeavingReport.fulfilled, handleSearch.fulfilled), (state, action) => {
      state.loadingWeaving = false;
      state.weavings = action.payload.results;
      state.count = action.payload.count;
      state.previous = action.payload.previous;
      state.next = action.payload.next;
    });
    builder.addMatcher(isAnyOf(getWeavingReport.rejected, handleSearch.rejected), (state) => {
      state.loadingWeaving = false;
    });
  },
});

export const {} = weavingReportSlice.actions;

export default weavingReportSlice.reducer;
